<span class="effect"
    [ngClass]="{'fh': edition == 'fh', 'city': eventType == 'city', 'disabled': disabled && !selected}">
    <span *ngIf="effectString" class="text" [ngClass]="{'inline': inline}">
        <span [ngClass]="{'text-white': light}" [ghs-label]="effectString"></span>
    </span>
    <span *ngIf="effectObject" class="effect-object">
        <ghs-event-card-condition *ngIf="effectObject.condition" [condition]="effectObject.condition"
            [edition]="edition" [eventType]="eventType" [light]="light"></ghs-event-card-condition>

        <span *ngIf="effectObject.type && effectObject.type != 'choose' && effectObject.type != 'checkbox'"
            [ngClass]="{'text-white': light, 'inline': inline}"
            [ghs-label]="'game.events.effects.' + effectObject.type + (effectObject.alt ? '.alt': '')"
            [ghs-label-args]="labelArgs"></span>

        <span class="choose" *ngIf="effectObject.type == 'choose'">
            <span [ngClass]="{'text-white': light}" [ghs-label]="'game.events.effects.choose.prefix'"></span>
            <ng-container *ngFor="let chooseEffect of effects; let i = index;">
                <span *ngIf="i > 0" [ngClass]="{'text-white': light}"
                    [ghs-label]="'game.events.effects.choose.connector'"></span>
                <ghs-event-card-effect [effect]="chooseEffect" [edition]="edition" [eventType]="eventType"
                    [light]="light" [inline]="true"></ghs-event-card-effect>
            </ng-container>
            <span [ngClass]="{'text-white': light}" [ghs-label]="'game.events.effects.choose.suffix'"></span>
        </span>

        <span class="checkbox-container" *ngIf="effectObject.type == 'checkbox'">
            <label *ngFor="let chooseEffect of effects; let i = index;" [ngClass]="{'has-value': chooseEffect}">
                <span class="checkbox" [ngClass]="{'light': light}"></span>
                <ghs-event-card-effect *ngIf="chooseEffect" [effect]="chooseEffect" [edition]="edition"
                    [eventType]="eventType" [light]="light"></ghs-event-card-effect>
            </label>
        </span>
        <span class="automation-icon" [ngClass]="{'light': light}"
            *ngIf="settingsManager.settings.eventsApply && EventCardApplyEffects.indexOf(effectObject.type) != -1"
            [ghs-tooltip]="'game.events.effects.automation'">
            <img class="hint-trigger ghs-svg" src="./assets/images/automation.svg">
        </span>
    </span>

</span>